import { render } from "./AddSpecialDayForm.vue?vue&type=template&id=458a542d"
import script from "./AddSpecialDayForm.vue?vue&type=script&lang=js"
export * from "./AddSpecialDayForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bahramhasanov/_PHP/bouquet-new-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__